import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {CollectionModel} from "../../shared/models/collection.model";
import {StationModel} from "../../shared/models/station.model";
import {VariablePublicNamesMap} from "../../shared/utils/variable-display-name";

interface CollectionAvailableData {
  [variableName: string]: {
    station: string;
    fromDate: string;
    toDate: string;
    depths: number[];
  }[];
}

@Component({
  selector: 'app-product-page-data',
  templateUrl: './product-page-data.component.html',
  styleUrls: ['./product-page-data.component.scss']
})
export class ProductPageDataComponent implements OnInit, OnDestroy {
  @ViewChild('summaryCard') variableListRef!: ElementRef;
  @Input() collectionId: string | null = null;
  @Input() collection: CollectionModel;
  @Input() allStations: StationModel[] = [];
  @Input() collectionAvailableData: CollectionAvailableData;
  @Input() variableKeys: string[] = [];
  @Input() datasetStations: string[] = [];
  /** #23 — configured public names, keyed by technical identifier; owned by the page. */
  @Input() publicNamesMap: VariablePublicNamesMap = {};
  @Output() sendActiveVariable = new EventEmitter<string>();
  minAvailableDate: string | null = null;
  maxAvailableDate: string | null = null;
  selectedKey: string | null = null;
  variableSearchTerm: string = '';

  constructor() {
  }

  ngOnInit(): void {
    this.setDateRangeFromAvailableData();
  }

  get filteredVariableKeys(): string[] {
    if (!this.variableSearchTerm) {
      return this.variableKeys;
    }

    const term = this.variableSearchTerm.toLowerCase();
    return this.variableKeys.filter(key => key.toLowerCase().includes(term));
  }

  private setDateRangeFromAvailableData(): void {
    const dates: Date[] = [];

    this.variableKeys.forEach(key => {
      this.collectionAvailableData[key].forEach((entry: any) => {
        if (entry.fromDate) dates.push(new Date(entry.fromDate));
        if (entry.toDate) dates.push(new Date(entry.toDate));
      });
    });

    if (dates.length) {
      this.minAvailableDate = new Date(Math.min(...dates.map(d => d.getTime()))).toISOString();
      this.maxAvailableDate = new Date(Math.max(...dates.map(d => d.getTime()))).toISOString();
    }
  }

  updateActiveStation(key: string): void {
    if (key === this.selectedKey) {
      this.selectedKey = null;
    } else {
      this.selectedKey = key;
    }
    this.sendActiveVariable.next(this.selectedKey);
  }

  ngOnDestroy(): void {
    this.collectionId = null;
  }
}
